export default function (s) {
    return s.toString().replace(/\$|,/g, '');
}
